import { isRecord } from "../Editor/utils/typePredicates";

export interface BoxModelValues {
  [key: string]: string | number;
}

export interface ResponsiveValue {
  desktop: string | number | BoxModelValues;
  mobile: string | number | BoxModelValues;
  tablet: string | number | BoxModelValues;
}

const RESPONSIVE_SIZE_SIZES = ["desktop", "tablet", "mobile"];

const isValidResponsiveValue = (value: unknown): boolean => {
  if (typeof value === "string" || typeof value === "number") {
    return true;
  }

  if (isRecord(value)) {
    return Object.values(value).every(
      val => typeof val === "string" || typeof val === "number",
    );
  }

  return false;
};

export const isResponsiveValue = (value: unknown): value is ResponsiveValue => {
  if (!isRecord(value)) {
    return false;
  }

  const keys = Object.keys(value);

  return (
    keys.length === 3 &&
    keys.every(key => RESPONSIVE_SIZE_SIZES.includes(key)) &&
    keys.every(key => isValidResponsiveValue(value[key]))
  );
};
